<template>
    <div>
        <v-row dense>

            <!-- ROUTED in / OUT -->
            <v-col cols="12" xl="2" lg="2" md="4" sm="6" xs="12"
                   v-if="project && project.routed_in_count > 0 || project.routed_out_count > 0">
                <stat-box-numerical
                        color="primary"
                        :value="project.routed_in_count"
                        hint="# of routed in"
                        :mouse-over-value="project.routed_out_count"
                        mouse-over-hint="# of routed out"
                ></stat-box-numerical>
            </v-col>

            <v-col cols="12" xl="2" lg="2" md="4" sm="6" xs="12" v-if="showInviteStats">
                <!-- INVITED & REMINDED-->
                <stat-box-numerical
                        :color="project.invited_count === 0 ? 'red darken-2' : 'primary'"
                        :value="project.invited_count"
                        hint="# of invitations sent"
                        :mouse-over-value="project.reminded_count"
                        mouse-over-hint="# of reminders sent"
                ></stat-box-numerical>
            </v-col>

            <!-- DELIVERY PERCENT -->
            <v-col cols="12" xl="2" lg="2" md="4" sm="6" xs="12" v-if="showInviteStats">
                <stat-box-numerical
                        :value="deliveryPercent"
                        hint="Delivered"
                        postfix="%"
                        :mouse-over-value="project.delivered_count"
                        mouse-over-hint="# of delivered"
                ></stat-box-numerical>
            </v-col>

            <!-- OPEN PERCENT -->
            <v-col cols="12" xl="2" lg="2" md="4" sm="6" xs="12" v-if="showInviteStats">
                <stat-box-numerical
                        :value="openPercent"
                        hint="Opened"
                        postfix="%"
                        :mouse-over-value="project.opened_count"
                        mouse-over-hint="# of opened"
                ></stat-box-numerical>
            </v-col>

            <!-- BOUNCED PERCENT -->
            <v-col cols="12" xl="2" lg="2" md="4" sm="6" xs="12" v-if="showInviteStats">
                <stat-box-numerical
                        :color="bouncedColor"
                        :value="project.bounced_count"
                        hint="Bounced"
                ></stat-box-numerical>
            </v-col>

            <!-- COMPLAINED COUNT -->
            <v-col cols="12" xl="2" lg="2" md="4" sm="6" xs="12" v-if="showInviteStats">
                <stat-box-numerical
                        :color="complainedColor"
                        :value="project.complained_count"
                        hint="Complaints"
                ></stat-box-numerical>
            </v-col>

        </v-row>
    </div>
</template>

<script>

import StatBoxNumerical from '../../../../components/UI/StatBoxNumerical';

export default {

    components: {
        StatBoxNumerical
    },

    props: {
        project: {
            type: Object,
            required: true
        }
    },

    data() {
        return {}
    },

    computed: {
        showInviteStats() {
            return this.project && this.project.invited_count > 0;
        },

        bouncedColor() {
            if (!this.project.id) return null;

            if (this.project.invited_count === 0) return 'green';

            let bouncePercent = this.project.bounced_count / this.project.invited_count * 100;
            if (bouncePercent > 3) return 'red';
            if (bouncePercent > 1) return 'orange darken-1';
            return 'green';
        },

        complainedColor() {
            if (!this.project.id) return null;

            if (this.project.complained_count === 0) return 'green';
            if (this.project.complained_count > 10) return 'red';
            if (this.project.complained_count > 1) return 'orange darken-1';
            return 'green';
        },

        deliveryPercent() {
            if (!this.project.id) return null;

            if (this.project.invited_count === 0) return 0;

            return Math.round(this.project.delivered_count / this.project.invited_count * 100);
        },

        openPercent() {
            if (this.project.id) {

                if (this.project.opened_count + this.project.invited_count === 0) return 0;

                return Math.round(this.project.opened_count / this.project.invited_count * 100);
            }
            return null;
        }
    },
}
</script>
